GP.GPMod('DailySpotlight',function(self){
    var vent   = null;
    var common = null;
    var _log   = null;

    var _conf = {
        // prices are in credits
        prices: {
            CITY:          100,
            STATE_COUNTRY: 500
        },
        success_modal_timeout:  4000
    };

    var _data = {
        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            common = self.app.Util;
            _log   = self.app.Util.log;

            if (typeof _daily_spotlight_credit_prices != 'undefined') {
                _conf.prices = _daily_spotlight_credit_prices;
            }
        },
        page:  1,
        limit: 1,
        override_confirm: false,
        processing_spotlight: false,
    };

    var gui = {
        init: function() {
            this.$body                   = $('body');
            this.$daily_spotlight_input  = $('.daily-spotlight-input');
            this.$btn_purchase_spotlight = $('.btn-purchase-daily-spotlight');
            this.$btn_purchase_credits   = $('.btn-credits-daily-spotlight');
        }
    };

    var apis = {
        get_spotlight_type: function() {
            var spotlight_type = 'CITY';

            $('.daily-spotlight-input').each(function() {
                if ($(this).is(':checked')) {
                    spotlight_type = $(this).val();
                }
            });
            return spotlight_type;
        },
        add_daily_spotlight: function() {
            $('.modal .error_container').hide();
            var spotlight_type = apis.get_spotlight_type();

            if (!_data.processing_spotlight) {
                _data.processing_spotlight = true;

                $.post('/members/user/daily_spotlight', {
                    'process' : 1,
                    'spotlight_type' : spotlight_type,
                    'ice_breaker_msg': $('#ice-breaker-select').val()
                })
                .done(function(json) {
                    if (json && json.success) {
                        handlers.spotlight_success();

                        vent.trigger('Modal:close', _conf.success_modal_timeout);
                    } else {
                        handlers.spotlight_error(json);
                    }
                })
                .fail(function() {
                    handlers.spotlight_error();
                })
                .always(function() {
                    _data.processing_spotlight = false;
                });
            }
        },
        get_next_daily_spotlight_user: function() {
            self.api.json('user.get_daily_spotlight_user', {
                data:    {
                    page:  ++_data.page,
                    limit: _data.limit
                },
                error:   function() {},
                success: function(json) {
                    if (json && json.html) {
                        $('#daily-spotlight').replaceWith(json.html);
                        events.setup_next_user();
                    }
                }
            });
        }
    };

    var handlers = {
        spotlight_success: function() {
            var $success_container = $('.modal .success_container');
            $success_container.show();
            setTimeout(function() {
                $success_container.hide();
            }, 3000);
        },
        spotlight_error: function(json) {
            var error_message = 'Daily Spotlight error occured';

            if (json && json.error) {
                error_message = json.error;
            } else if (typeof _daily_spotlight_default_error != 'undefined' && _daily_spotlight_default_error) {
                error_message = _daily_spotlight_default_error;
            }

            var $error_container = $('.modal .error_container');
            $error_container.find('p').remove();

            $error_container.append('<p class="error">'+error_message+'</p>');
            $error_container.show();

            // setTimeout(function() {
            //     $error_container.hide();
            // }, 3000);
        }
    };

    var events = {
        init: function() {
            vent.on(self.moduleName+":setup_modal",events.setup_modal);

            vent.on('init_js:user:home', function() {
                _data.page = _data.limit = 1;
                events.setup_next_user();
            });

            // turn off fl_check_spotlight_type custom event when modal closes
            $(document).on('fl_modal_closed', function() {
                $('body').off('fl_check_spotlight_type');
            });
        },
        setup_next_user: function() {
            $('#daily-spotlight .next-user').on('click', function(e) {
                e.preventDefault();
                apis.get_next_daily_spotlight_user();
            });
        },
        setup_modal: function() {
            _data.init();
            gui.init();

            // setup the bind for the poke submit button to send to daily_spotlight
            $('#btn-ice-breaker').on('click', function(e) {
                e.preventDefault();
                apis.add_daily_spotlight();
            });

            // attempt to add user to daily spotlight table via ajax
            $('.btn-purchase-daily-spotlight').on('click', function() {
                apis.add_daily_spotlight();
            });
            // show the purchase credits modal if we don't have enough credits
            $('.btn-credits-daily-spotlight').on('click', function() {
                if (GP.sdata.my_user.membership == 'BRONZE') {
                    window.location.href = GP.Util.clean_url('/members/billing/add_credits/', {'hide_earn_credits': 1});
                } else {
                    events.show_purchase_credits();
                }
            });
            $('.daily-spotlight-input').on('change', function() {
                if ($(this).val() == 'STATE_COUNTRY') {
                    events.check_credits();
                }
            });

            events.show_submit_btn();
        },
        show_purchase_credits: function() {
            var _self = this;

            // bind to custom event that the iframe success template will trigger
            $('body').one('fl_credits_purchased', function(e) {
                _oc = false;

                // if this is called, we don't need to use the fl_modal_closed event
                $(document).off('fl_modal_closed');

                // give the PB some time to update the DB and fire the mod_user_credits cometd message
                // which should update the user's shared data (sdata)
                setTimeout(function() {
                    $('#daily-spotlight-form').show();
                    $('iframe.daily-spotlight-frame').hide();
                    events.show_purchase_btn();

                    // if we have credits now, call the add_daily_spotlight() api
                    if (GP.sdata.my_user.credits > 0) {
                        apis.add_daily_spotlight();
                    } else {
                        // check/refresh credits via ajax call, and call add_daily_spotlight if we have enough credits
                        events.refresh_credits(_self);
                    }
                }, 2000);
            });

            // trigger custom event to re-evaluate the radio buttons to show/hide credit products based on radio selected
            $('body').trigger('fl_check_spotlight_type');

            $('#daily-spotlight-form').hide();
            $('iframe.daily-spotlight-frame').show();
        },
        show_submit_btn: function() {
            if (GP.sdata.my_user.credits >= _conf.prices.CITY) {
                events.show_purchase_btn();
            } else {
                events.show_purchase_credits_btn();
            }
        },
        show_purchase_btn: function() {
            gui.$btn_purchase_spotlight.removeClass('hide');
            gui.$btn_purchase_credits.addClass('hide');
        },
        show_purchase_credits_btn: function() {
            gui.$btn_purchase_spotlight.addClass('hide');
            gui.$btn_purchase_credits.removeClass('hide');
        },
        hide_ds_submit_btns: function() {
            gui.$btn_purchase_spotlight.addClass('hide');
            gui.$btn_purchase_credits.addClass('hide');
        },
        refresh_credits: function(_self) {
            vent.trigger('User:check_credits', _self, function(json) {
                var new_credits = parseInt(json.credits, 10);
                var price = _conf.prices[apis.get_spotlight_type()];
                if (new_credits >= price) {
                    // pass apis.add_daily_spotlight as a callback so it fires after updating credits
                    vent.trigger('User:mod_user_credits', json,  apis.add_daily_spotlight, _self);
                }
            });
        },
        check_credits: function() {
            if (GP.sdata.my_user.credits < _conf.prices.STATE_COUNTRY) {
                events.show_purchase_credits_btn();
            }
        }
    };

    this.addInitializer(function(){
        _data.init();
        events.init();
        gui.init();
    });
});
